export default {
    name: '试卷管理',
    permissionsKey:"YY-SJGL",
    icon: 'fa fa-desktop',
    children: {
        courseList:{
            name: '试卷列表',
            permissionsKey:"YY-SJGL-SJLB",
            path: '/testpaper_manage/testpaper_list',
        },
    }
};
